import axios from 'axios';
import { clearAccessToken, setAccessTokenFromResponse } from './authTokenStore';
import { resolveGatewayBackedServiceBaseUrl } from './serviceBaseUrl';

const API_BASE = resolveGatewayBackedServiceBaseUrl(process.env.REACT_APP_API_URL);

const DEFAULT_CONFIG = {
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
};

const AUTH_SESSIONS_URL = `${API_BASE}/api/auth/sessions`;
const AUTH_PASSWORD_SETUP_URL = `${API_BASE}/api/auth/me/password-setup/start`;

const requireSessionId = (sessionId) => {
  if (typeof sessionId !== 'string' || sessionId.trim() === '') {
    throw new Error('sessionId is required');
  }
  return encodeURIComponent(sessionId.trim());
};

export const accountService = {
  changePassword: async ({ currentPassword, newPassword }) => {
    const url = `${API_BASE}/api/auth/change-password`;
    const payload = { currentPassword, newPassword };
    const resp = await axios.post(url, payload, DEFAULT_CONFIG);
    setAccessTokenFromResponse(resp?.data);
    return resp.data;
  },

  startPasswordSetup: async () => {
    const resp = await axios.post(AUTH_PASSWORD_SETUP_URL, null, DEFAULT_CONFIG);
    return resp.data;
  },

  listActiveSessions: async () => {
    const resp = await axios.get(AUTH_SESSIONS_URL, DEFAULT_CONFIG);
    return Array.isArray(resp?.data?.sessions) ? resp.data.sessions : [];
  },

  terminateSession: async (sessionId) => {
    const resp = await axios.delete(`${AUTH_SESSIONS_URL}/${requireSessionId(sessionId)}`, DEFAULT_CONFIG);
    const data = resp?.data || {};
    if (data.currentSessionTerminated === true) {
      clearAccessToken();
    }
    return data;
  }
};
